import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useNavigation } from '../hooks/useNavigation';

/**
 * Componente para proteger rutas basado en roles
 */
const ProtectedRoute = ({ children }) => {
  const { canAccessRoute, getDefaultRoute } = useNavigation();
  const location = useLocation();

  const hasAccess = canAccessRoute(location.pathname);

  if (!hasAccess) {
    return <Navigate to={getDefaultRoute} replace />;
  }

  return children;
};

export default ProtectedRoute;
